import axios from '@axios'

export default {
    namespaced: true,
    state: {
        roles: [],
        servidores: [],
        servidoresAll: [],
        rolesAll: [],
        rutas: [],
        subRutas: [],
        rutasAll: [],
        subRutasAll: [],
        rutasRol: [],
        usuarios: [],
        empresas: [],
        aplicaciones: [],
        users: [],
        estabFabProcArea: [],
        permisosSalem: [],
        bots: [],
    },
    getters: {
        getRoles(state) {
            return state.roles
        },
        getServidores(state) {
            return state.servidores
        },
        getServidoresAll(state) {
            return state.servidoresAll
        },
        getRolesAll(state) {
            return state.rolesAll
        },
        getRutas(state) {
            return state.rutas
        },
        getRutasAll(state) {
            return state.rutasAll
        },
        getSubRutas(state) {
            return state.subRutas
        },
        getSubRutasAll(state) {
            return state.subRutasAll
        },
        getRutasRol(state) {
            return state.rutasRol
        },
        getUsuarios(state) {
            return state.usuarios
        },
        getEmpresas(state) {
            return state.empresas
        },
        getAplicaciones(state) {
            return state.aplicaciones
        },
        getUsers(state) {
            return state.users
        },
        getEstabFabProcArea(state) {
            return state.estabFabProcArea
        },
        getPermisosSalem(state) {
            return state.permisosSalem
        },
        getBots(state) {
            return state.bots
        },
    },
    mutations: {
        setRoles(state, roles) {
            state.roles = roles
        },
        setServidores(state, servidores) {
            state.servidores = servidores
        },
        setServidoresAll(state, servidoresAll) {
            state.servidoresAll = servidoresAll
        },
        setRolesAll(state, rolesAll) {
            state.rolesAll = rolesAll
        },
        setRutas(state, rutas) {
            state.rutas = rutas
        },
        setRutasAll(state, rutasAll) {
            state.rutasAll = rutasAll
        },
        setSubRutas(state, subRutas) {
            state.subRutas = subRutas
        },
        setSubRutasAll(state, subRutasAll) {
            state.subRutasAll = subRutasAll
        },
        setRutasRol(state, rutasRol) {
            state.rutasRol = rutasRol
        },
        addRutasRol(state, rutaRol) {
            state.rutasRol.push(rutaRol)
        },
        setUsuarios(state, usuarios) {
            state.usuarios = usuarios
        },
        setEmpresas(state, empresas) {
            state.empresas = empresas
        },
        setAplicaciones(state, aplicaciones) {
            state.aplicaciones = aplicaciones
        },
        setUsers(state, users) {
            state.users = users
        },
        setEstabFabProcArea(state, estabFabProcArea) {
            state.estabFabProcArea = estabFabProcArea
        },
        setPermisosSalem(state, permisosSalem) {
            var json = JSON.stringify(permisosSalem)
            json = json.replaceAll(',"children":[]', '').replaceAll('"children":[]', '')
            json = JSON.parse(json)
            state.permisosSalem = json
        },
        setBots(state, bots) {
            state.bots = bots
        },
    },
    actions: {
        fetchRoles({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/roles', { params: data })
                    .then(response => {
                        commit('setRoles', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRolesAll({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/rolesAll')
                    .then(response => {
                        commit('setRolesAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        enviarRol({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/roles', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchServidores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/servidores', { params: data })
                    .then(response => {
                        commit('setServidores', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        enviarServidor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/servidores', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchServidoresAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/servidoresAll')
                    .then(response => {
                        commit('setServidoresAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        enviarRuta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/rutasRol', { ruta: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRutas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/rutas', data)
                    .then(response => {
                        commit('setRutas', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRutasAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/rutasAll')
                    .then(response => {
                        commit('setRutasAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        enviarSubRuta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/subRutas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchSubRutas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/subRutas', { params: data })
                    .then(response => {
                        commit('setSubRutas', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchSubRutasAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/subRutasAll')
                    .then(response => {
                        commit('setSubRutasAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRutasRol({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/rutasRol', { params: data })
                    .then(response => {
                        commit('setRutasRol', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchUsuarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/usuarios', { params: data })
                    .then(response => {
                        commit('setUsuarios', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchUsuariosV2({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/sistemas/usuarios', { params: data })
                    .then(response => {
                        commit('setUsuarios', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEmpresas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/empresas')
                    .then(response => {
                        commit('setEmpresas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAplicaciones({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/aplicaciones')
                    .then(response => {
                        commit('setAplicaciones', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        desactivarUsuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .delete('/api/auth/sistemas/usuario', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        crearUsuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/usuario', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchUsers({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/user', { params: params })
                    .then(response => {
                        commit('setUsers', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEstabFabProcArea({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/estabFabProcArea')
                    .then(response => {
                        commit('setEstabFabProcArea', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        cargarPermisosMovMatPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/guardarPermisosMovMatPrima', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        cargarCopiarPermisosMovMatPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/guardarCopiarPermisosMovMatPrima', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPermisosSalem({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/permisosSalem', { params })
                    .then(response => {
                        commit('setPermisosSalem', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchUsuarioPermisosSalem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/getUsuarioPermisosSalem', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchUsuarioPermisosMovMatPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/getUsuariosPermisosMovMatPrima', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        cargarPermisosSalem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/guardarPermisosSalem', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        cargarCopiarPermisosSalem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/guardarCopiarPermisosSalem', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        guardarModificarPermisosSalem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/guardarModificarPermisosSalem', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        guardarModificarMovMatPrima({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/guardarModificarMovMatPrima', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        consultarBots({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemas/bots', { params: data })
                    .then(response => {
                        commit('setBots', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarBots({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemas/modificarBots', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
